import React, { useEffect, useState, useMemo } from "react";
import { fetchDelegates } from "@/lib/adminApi";
import { PageHeader, StatCard, fmtMoney } from "./_shared";
import LeadTable from "./LeadTable";
import LeadDrawer from "./LeadDrawer";
import { Flame } from "lucide-react";

export default function AbandonedPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  useEffect(() => {
    fetchDelegates("abandoned").then((d) => { setRows(d); setLoading(false); });
  }, []);

  const potential = useMemo(() => {
    return rows.reduce((acc, r) => {
      const cur = r.extra?.currency || "INR";
      acc[cur] = (acc[cur] || 0) + (r.extra?.total_amount || 0);
      return acc;
    }, {});
  }, [rows]);

  const uncontacted = rows.filter(r => !r.extra?.contacted).length;
  const under24h = rows.filter(r => (Date.now() - new Date(r.created_at).getTime()) < 24 * 36e5).length;

  return (
    <div data-testid="page-abandoned">
      <PageHeader
        title="Abandoned Checkouts"
        subtitle="High-intent leads who started registration but never paid. Call them today."
        actions={<div className="rounded-full bg-amber-100 px-3 py-1.5 text-xs font-semibold text-amber-800 flex items-center gap-1.5"><Flame className="h-3.5 w-3.5"/> Highest ROI list</div>}
      />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <StatCard tone="amber" label="Total abandoned" value={rows.length} />
        <StatCard tone="rose" label="Untouched" value={uncontacted} sub="Need outreach" />
        <StatCard tone="lime" label="Fresh (<24h)" value={under24h} sub="Recover fast" />
        <StatCard tone="navy" label="Potential revenue" value={`${fmtMoney(potential.INR || 0, "INR")}${potential.USD ? " + " + fmtMoney(potential.USD, "USD") : ""}`} />
      </div>

      {loading ? <div className="text-sm text-slate-500">Loading…</div> : (
        <LeadTable
          rows={rows}
          setRows={setRows}
          onRowClick={setActive}
          showFormType={false}
          showPayment
          filename="bef2026-abandoned.csv"
          emptyText="No abandoned checkouts. Nice conversion rate!"
        />
      )}

      <LeadDrawer
        lead={active}
        onClose={() => setActive(null)}
        onChange={(u) => { setRows((prev) => prev.map((x) => x.id === u.id ? u : x)); setActive(u); }}
        onDelete={(id) => setRows((prev) => prev.filter((x) => x.id !== id))}
      />
    </div>
  );
}
